<template>
  <div >
    <v-card class="pa-8 grey lighten-3">
      <h4 class="cyan--text text--darken-2 font-weight-bold">باشگاه مشتریان</h4>
      <hr />
      <div>
        <p class="text-justify mb-10">
          باشگاه مشتریان در اثر گرد آوردن مشتریان یک مجموعه کنار هم و ثبت
          اطلاعات آن‌ها به وجود می‌آید. ثبت این موارد در قالب یک بانک اطلاعات،
          امکان برنامه‌ریزی مدون برای آن‌ها را فراهم می‌آورد. در این بستر به رفع
          نیازهای مشتریان، توجه ویژه به آن‌ها و مدیریت صحیح ارتباط با مشتریان
          پرداخته می‌شود. باشگاه مشتریان، راهکاری نوین بوده و تنها مورد استفاده
          شماری از شرکت‌های تجاری قرار گرفته است. این راهکار، انگیزه‌های ویژه‌ای
          برای مشتریان فعلی و آینده نگر ایجاد نموده و موجب تلاش ایشان برای
          پیوستن به باشگاه می‌گردد.
        </p>
        <p class="text-justify mb-10">
          به طور کلی، باشگاه مشتریان برای تأمین نیازها و ایجاد منافع بیشتر برای
          مشتریان در برندهای تجاری شکل می‌گیرد. اجتماع مشتریان در یک شبه تشکل،
          احساس ارزشمندی را در ایشان تقویت نموده و در نهایت، وفاداری آن‌ها را به
          مجموعه‌ها بیشتر کند.
        </p>
        <p class="text-justify mb-10">
          به صورت خلاصه، در یک باشگاه مشتریان، احترام‌گذاری و ارزش نهادن به
          مشتری با جلب وفاداری وی معاوضه می‌گردد. در نتیجه این توضیحات، قابل
          پیش‌بینی است که در منطق راهکار باشگاه مشتریان، مشتریان بلندمدت از سود
          بیشتری به نسبت مشتریان موقت برخوردار خواهند شد. یعنی، هر چه وفاداری و
          ماندگاری مشتری بیشتر شود، فروش و سود نیز به همان نسبت افزایش می‌یابد .
        </p>
        <h5 class="cyan--text text--darken-2">
          ویژگی‌های تعبیه شده برای یک باشگاه مشتریان موارد زیر را دربرمی‌گیرد:
        </h5>
        <ul class="ps-5">
          <li>امکان سطح‌بندی مشتریان</li>
          <li>امکان امتیاز‌دهی به مشتریان از طریق خریدها</li>
          <li>امکان تعریف نحوه ورود به باشگاه از طریق هزینه‌ها</li>
          <li>امکان تعریف پاداش‌های ویژه و جذاب برای خریداران وفادار و ویژه</li>
          <li>امکان تعریف زمان انقضای استفاده از هر یک از انواع امتیازات</li>
          <!-- <li>امکان ایجاد درصد دریافت امتیاز ویژه برای کاربران وفادار</li> -->
        </ul>
      </div>
    </v-card>
  </div>
  <!-- <div class="options pb-9">
    
     <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3"> </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2">تنظیمات باشگاه مشتریان</h4> -->
  <!-- <v-divider class="me-10 ms-10" vertical></v-divider>
        <div class="custom-input2">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle</v-icon
              >
            </template>
          </v-text-field>
        </div> -->
  <!-- </div>
      <hr class="mt-5" />

      <v-card v-if="busy" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <cube></cube>
          <span> در حال بارگذاری اطلاعات...</span>
        </div>
      </v-card>
      <div v-else class="custom-table mt-3">
        <h4 class="c-purple my-12">مدیریت دریافت امتیاز</h4>

        <b-table
          responsive
          show-empty
        
          :current-page="currentPage"
          :per-page="perPage"
          :items="options"
          :fields="optionsFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد."
          thead-class="headClass"
          tbody-class="bodyClass"
        
        >
          <template v-slot:empty>
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              رکوردی برای نمایش وجود ندارد.
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(tierMinimumPrice)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 200px"
              class="d-flex flex-row mx-auto"
            >
              <vuetify-money
                v-model="data.item.tierMinimumPrice"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                class="me-4"
                style="margin-top: -23px"
                type="number"
                outlined
                dense
              />
              <div style="margin-top: -3px">ریال</div>
            </div>
            <div
              class="red--text pt-3 font-weight-bold mx-auto"
              style="font-size: 12px"
              v-if="!computedValidAmount(data.value, data.index)"
            >
              <v-icon small class="red--text">mdi-alert-outline</v-icon>
              مبلغ ورودی باید بیشتر از سطح پیشین و کمتر از سطح بالاتر باشد.
            </div>
          </template>
          <template v-slot:cell(vipRoyaltyPercentage)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 200px"
              class="d-flex flex-row mx-auto"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="0"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                :rules="[rules.validPercentage]"
                v-model="data.item.vipRoyaltyPercentage"
              >
              </v-text-field>
              <div style="margin-top: -3px">% از مبلغ فاکتور</div>
            </div>
          </template>
          <template v-slot:cell(normalRoyaltyPercentage)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 200px"
              class="d-flex flex-row mx-auto"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="0"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                v-model="data.item.normalRoyaltyPercentage"
              >
              </v-text-field>
              <div style="margin-top: -3px">% از مبلغ فاکتور</div>
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <span v-show="false">{{ reactivity }}</span>
              <v-btn
                class="purple-mainBtn"
                width="130"
                :loading="loading[data.index]"
                :disabled="
                  !options[data.index].tierMinimumPrice ||
                  !options[data.index].normalRoyaltyPercentage ||
                  !options[data.index].vipRoyaltyPercentage ||
                  !computedValidAmount(
                    options[data.index].tierMinimumPrice,
                    data.index
                  )
                "
                @click="editCredit(data.item, data.index)"
                >اعمال تغییرات
                <v-icon class="ms-2" style="margin-top: -6px"
                  >$Edit</v-icon
                ></v-btn
              >
            </div>
          </template>
        </b-table>

        <br />
        <br />
        <br />

        <h4 class="c-purple my-12">زمان انقضای امتیاز</h4>
        <b-table
          responsive
          show-empty
          :current-page="currentPage"
          :per-page="perPage"
          :items="times"
          :fields="timesFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد."
          thead-class="headClass"
          tbody-class="bodyClass"
        >
          <template v-slot:empty>
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              رکوردی برای نمایش وجود ندارد.
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(normalCreditPeriod)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 150px"
              class="d-flex flex-row mx-auto"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="1"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                v-model="data.item.normalCreditPeriod"
              >
              </v-text-field>
              <div style="margin-top: -3px">ماه</div>
            </div>
          </template>
          <template v-slot:cell(vipCreditPeriod)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 150px"
              class="d-flex flex-row mx-auto"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="1"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                v-model="data.item.vipCreditPeriod"
              >
              </v-text-field>
              <div style="margin-top: -3px">ماه</div>
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <v-btn
                class="purple-mainBtn"
                width="120"
                :loading="loading2"
                @click="editTime(data.item)"
                >اعمال تغییرات
                <v-icon class="ms-2" style="margin-top: -6px"
                  >$Edit</v-icon
                ></v-btn
              >
            </div>
          </template>
        </b-table>
      </div>
    </v-card>
  </div> -->
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
// import { AtomSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import MyCalendar from "../../components/MyCalendar.vue";

export default {
  components: {
    // AtomSpinner,
    MyCalendar,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      tab: null,
      rules: {
        validPercentage: (value) => Number(value) < 100 || "",
      },
      reactivity: false,
      moment: moment,
      allExchanges: [],
      filter: "",
      guide: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      options: [],
      times: [],
      loading: [false, false, false, false],
      loading2: false,
      busy: false,
      startDate: "",
      endDate: "",
      type: Var.allTypes[3],
      expirationTimes: [
        {
          specialDuration: 6,
          duration: 1,
        },
      ],
      optionsFields: [
        // { key: "index", label: "ردیف" },
        { key: "name", label: "سطح‌بندی مشتری" },
        { key: "tierMinimumPrice", label: "حداقل میزان خرید برای ورود به سطح" },
        {
          key: "vipRoyaltyPercentage",
          label: "درصد دریافت امتیاز ویژه وفاداری",
        },
        { key: "normalRoyaltyPercentage", label: "درصد دریافت امتیاز وفاداری" },
        { key: "operation", label: "عملیات" },
      ],
      timesFields: [
        // { key: "index", label: "ردیف" },
        { key: "vipCreditPeriod", label: "طول مدت امتیاز ویژه وفاداری" },
        { key: "normalCreditPeriod", label: "طول مدت امتیاز وفاداری" },
        { key: "operation", label: "عملیات" },
      ],
    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    getOptions() {
      this.busy = true;
      Axios.get(this.baseUrl + "/ppkpms/options/getOptions", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.busy = false;
            let options = res.data;
            for (let prop in options) {
              if (prop != "creditDiscountTime") {
                this.options.push(options[prop] ? options[prop] : "");
              }
            }
            this.times.push(res.data.creditDiscountTime);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    editCredit(item, index) {
      this.loading[index] = true;
      this.reactivity = !this.reactivity;
      console.log(item);
      Axios.post(
        this.baseUrl + "/ppkpms/options/newOption",
        {
          key: item.enName,
          value: {
            name: item.name,
            enName: item.enName,
            vipRoyaltyPercentage: Number(item.vipRoyaltyPercentage),
            normalRoyaltyPercentage: Number(item.normalRoyaltyPercentage),
            tierMinimumPrice: Number(item.tierMinimumPrice),
          },
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.loading[index] = false;
            this.reactivity = !this.reactivity;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading[index] = false;
            this.reactivity = !this.reactivity;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading[index] = false;
          this.reactivity = !this.reactivity;
        });
    },
    editTime(item) {
      this.loading2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/option/newOption",
        {
          key: "creditDiscountTime",
          value: {
            vipCreditPeriod: item.vipCreditPeriod,
            normalCreditPeriod: item.normalCreditPeriod,
          },
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.loading2 = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading2 = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading2 = false;
        });
    },
    computedValidAmount(value, index) {
      if (index != 0 && value) {
        if (value > this.options[Number(index) - 1].tierMinimumPrice) {
          return true;
        } else return false;
      } else return true;
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.options {
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot {
    background-color: #fff !important;
    border-radius: 8px !important;
  }
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .purple-borderedBtn {
    background-color: #f4f4ff !important;
  }
}

.credit-dialog-card {
  border-radius: 15px !important;
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #7634d6 !important;
        cursor: pointer;
      }
    }
  }
}
.inputPrice >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
